import {
  HIDE_NOTIFICATION,
  MARK_NOTIFICATION_READ,
  RECEIVE_NOTIFICATIONS,
  MARK_ALL_AS_READ,
  RECEIVE_PUSH_NOTIFICATION,
  TOGGLE_DO_NOT_DISTURB,
  INITIALIZE_DO_NOT_DISTURB
} from './actions/types';

const initialState = {
  notificationList: [],
  unreadCount:      0,
  doNotDisturbEnabled: false
};

function buildState(notificationList, doNotDisturbEnabled, unreadCount) {
  return ({
    notificationList: notificationList,
    unreadCount: unreadCount > 0 ? unreadCount : 0,
    doNotDisturbEnabled: doNotDisturbEnabled
  });
}

function hideNotification(state, id) {
  let removedNotification;
  const notificationList = state.notificationList.filter((notification) => {
    if (notification.id === id) {
      removedNotification = notification;
    }
    return id !== notification.id;
  });
  const unreadCount = (removedNotification && removedNotification.unread) ? state.unreadCount - 1 : state.unreadCount;
  return buildState(notificationList, state.doNotDisturbEnabled, unreadCount);
}

function markAllAsRead(state) {
  const notificationList = state.notificationList.map((notification) => {
    notification.unread = false;
    return notification;
  });
  return { notificationList, unreadCount: 0, doNotDisturbEnabled: state.doNotDisturbEnabled };
}

function markNotificationRead(state, id) {
  let unreadCount = state.unreadCount;
  const notificationList = state.notificationList.map((notification) => {
    if (notification.id === id) {
      if (notification.unread) {
        unreadCount -= 1;
      }
      notification.unread = false;
    }
    return notification;
  });
  return buildState(notificationList, state.doNotDisturbEnabled, unreadCount);
}

function toggleDoNotDisturb(state) {
  return buildState(state.notificationList, !state.doNotDisturbEnabled, state.unreadCount);
}

function initializeDoNotDisturb(state, doNotDisturbEnabled) {
  return buildState(state.notificationList, doNotDisturbEnabled, state.unreadCount);
}

function addNotification(state, notification) {
  const unreadCount = (notification && notification.unread) ? state.unreadCount + 1 : state.unreadCount;
  return notification ? buildState([notification, ...state.notificationList], state.doNotDisturbEnabled, unreadCount) : state;
}

export function Reducer(state = initialState, action) {
  switch (action.type) {
  case HIDE_NOTIFICATION:
    return hideNotification(state, action.payload.id);
  case MARK_ALL_AS_READ:
    return markAllAsRead(state);
  case MARK_NOTIFICATION_READ:
    return markNotificationRead(state, action.payload.id);
  case TOGGLE_DO_NOT_DISTURB:
    return toggleDoNotDisturb(state);
  case INITIALIZE_DO_NOT_DISTURB:
    return initializeDoNotDisturb(state, action.payload.doNotDisturbEnabled);
  case RECEIVE_NOTIFICATIONS:
    return buildState(action.payload.notificationList, state.doNotDisturbEnabled, action.payload.unreadCount);
  case RECEIVE_PUSH_NOTIFICATION:
    return addNotification(state, action.payload.notification);
  default:
    return state;
  }
}
